import { request } from "./request";
import {
  WarningSummaryParams,
  WarningPageParams,
  WarningSummaryResponse,
  WarningPageResponse,
  WarningStandardResponse,
  WarningSummaryVo,
} from "./types";

/**
 * 获取预警信息汇总
 * @param params 请求参数
 * @returns 预警汇总数据
 */
export const getWarningSummary = async (
  params?: WarningSummaryParams,
): Promise<WarningSummaryVo> => {
  try {
    const response: WarningSummaryResponse = await request.get(
      "/rabbit-liancan/earlyWarning/summary",
      {
        params,
      },
    );

    return response.data;
  } catch (error) {
    console.error("获取预警汇总数据失败:", error);
    throw error;
  }
};

/**
 * 分页查询预警信息列表
 * @param params 分页查询参数
 * @returns 分页预警信息数据
 */
export const getWarningPage = async (
  params?: WarningPageParams,
): Promise<WarningPageResponse> => {
  try {
    const response: WarningPageResponse = await request.get(
      "/rabbit-liancan/earlyWarning/page",
      {
        params,
      },
    );

    return response;
  } catch (error) {
    console.error("获取预警分页数据失败:", error);
    throw error;
  }
};

/**
 * 根据ID获取预警标准详情
 * @param id 预警标准ID
 * @returns 预警标准详情
 */
export const getWarningStandard = async (
  id: number,
): Promise<WarningStandardResponse> => {
  try {
    const response: WarningStandardResponse = await request.get(
      `/rabbit-liancan/earlyWarningStandard/detail?category=${id}`,
    );
    return response;
  } catch (error) {
    console.error("获取预警标准详情失败:", error);
    throw error;
  }
};

// 导出所有 API 函数
export const warningApi = {
  getSummary: getWarningSummary,
  getPage: getWarningPage,
  getStandard: getWarningStandard,
};
